import { useCallback } from 'react';
import { ConnectionHandler, type SelectorStoreUpdater } from 'relay-runtime';
import type { RemoveConnectionCallback } from '../types.tsx';

export function useDeleteRecord(
	itemsConnectionId: string,
	recordId: string,
	removeConnection: RemoveConnectionCallback,
) {
	return useCallback<SelectorStoreUpdater>(
		(store) => {
			assert(itemsConnectionId, 'itemsConnectionId');
			assert(recordId, 'recordId');

			const connectionRecord = store.get(itemsConnectionId);

			if (!connectionRecord) return;

			ConnectionHandler.deleteNode(connectionRecord, recordId);

			removeConnection({
				store,
				remainingIssueCount: connectionRecord.getLinkedRecords('edges')?.length ?? 0,
			});
		},
		[itemsConnectionId, recordId, removeConnection],
	);
}

function assertString(value: unknown, paramName: string): asserts value is string {
	if (typeof value !== 'string') throw new Error(`${paramName} must be a string`);
}

function assertNotEmpty(value: string, paramName: string) {
	if (value.trim().length === 0) throw new Error(`${paramName} must not be an empty string`);
}

function assert(value: string, paramName: string) {
	assertString(value, paramName);
	assertNotEmpty(value, paramName);
}
